import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import guiaTokio from "../../assets/guia-tokio.png";
import guiaKioto from "../../assets/guia-kioto.png";
import guiaNY from "../../assets/guia-ny.png";
import editorPreview from "../../assets/editor-preview.png";

const ACCENT = "#6366F1";
const MUTED = "#64748b";

const GuideDoorsSection = ({ onGuides, onCreate, sx }) => {
	return (
		<Grid
			container
			spacing={2}
			alignItems="stretch"
			sx={{ mb: { xs: 4, md: 5 }, ...sx }}
		>
			<Grid item xs={12} md={6} sx={{ display: "flex" }}>
				<DoorCard
					title="Nuestras guías"
					text="Tokio, Kioto, Nueva York… el itinerario ya está por días y zonas. Las abres y retocas lo que quieras."
					onClick={onGuides}
					cta="Ver guías"
					covers={[guiaTokio, guiaNY, guiaKioto]}
				/>
			</Grid>
			<Grid item xs={12} md={6} sx={{ display: "flex" }}>
				<DoorCard
					title="Tu guía"
					text="Empiezas en blanco: portada, días, mapas y stickers. El orden lo pones tú. Si prefieres, puedes editar nuestras guías con el editor."
					onClick={onCreate}
					cta="Empezar en blanco"
					preview={editorPreview}
					previewAlt="El editor de la guía"
				/>
			</Grid>
		</Grid>
	);
};

function DoorCard({ title, text, onClick, cta, covers, preview, previewAlt }) {
	return (
		<Box
			component="button"
			type="button"
			onClick={onClick}
			sx={{
				width: "100%",
				flex: 1,
				height: "100%",
				boxSizing: "border-box",
				textAlign: "left",
				border: "1px solid #ececf4",
				borderRadius: "20px",
				backgroundColor: "#fff",
				p: { xs: 2, md: 2.5 },
				cursor: "pointer",
				font: "inherit",
				display: "flex",
				flexDirection: "column",
				boxShadow: "0 12px 32px -20px rgba(15,23,42,0.28)",
				transition: "transform .2s ease, box-shadow .2s ease",
				"&:hover": {
					transform: { sm: "translateY(-3px)" },
					boxShadow: "0 20px 40px -20px rgba(15,23,42,0.32)",
				},
			}}
		>
			<Typography sx={{ fontWeight: 800, fontSize: "1.25rem", mb: 0.75 }}>
				{title}
			</Typography>
			<Typography
				sx={{
					color: MUTED,
					fontSize: "0.9375rem",
					lineHeight: 1.55,
					mb: 2,
					minHeight: "2.9em",
				}}
			>
				{text}
			</Typography>
			{covers && (
				<Box
					sx={{
						display: "flex",
						alignItems: "flex-end",
						height: 150,
						mb: 2,
						pl: 1,
						overflow: "hidden",
						flexShrink: 0,
					}}
				>
					{covers.map((src, i) => (
						<Box
							key={src}
							component="img"
							src={src}
							alt=""
							sx={{
								width: 96,
								height: 136,
								objectFit: "cover",
								objectPosition: "center 18%",
								borderRadius: "12px",
								border: "3px solid #fff",
								boxShadow: "0 12px 24px -10px rgba(15,23,42,0.35)",
								ml: i === 0 ? 0 : -2.5,
								position: "relative",
								zIndex: 3 - i,
								transform: i === 1 ? "translateY(-6px)" : "none",
							}}
						/>
					))}
				</Box>
			)}
			{preview && (
				<Box
					sx={{
						mb: 2,
						borderRadius: "14px",
						overflow: "hidden",
						border: "1px solid #ececf4",
						backgroundColor: "#f1f5f9",
						height: 150,
						flexShrink: 0,
					}}
				>
					<Box
						component="img"
						src={preview}
						alt={previewAlt || ""}
						sx={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
							objectPosition: "center 20%",
							display: "block",
						}}
					/>
				</Box>
			)}
			<Typography
				sx={{ mt: "auto", fontWeight: 700, color: ACCENT, fontSize: "0.9rem" }}
			>
				{cta} →
			</Typography>
		</Box>
	);
}

export default GuideDoorsSection;
